/* eslint-disable react/prop-types */
import React from "react";
import { Box, makeStyles } from "@material-ui/core";
import {
  filterCollectionByFilterName,
  getHiddenBrands,
  getHiddenCompanies,
} from "lib/utils/competitors";
import _ from "lodash";
import CompetitorAddItemsComponent from "./competitor_add_items_component/CompetitorAddItemsComponent";
import CompetitorCollapseRow from "./CompetitorCollapseRow";
import CompetitorSliderRow from "./CompetitorSliderRow";

const useStyles = makeStyles(() => ({
  mainContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    width: "100%",
    padding: "15px",
  },
  scenarioFiltersContainer: {
    borderRight: "1px solid #e4e4e4",
    width: "30%",
    padding: "15px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    gridAutoRows: "55px",
  },
  categoryContainer: {
    boxShadow: "0 1px 4px 0 rgba(37, 50, 56, 0.1)",
    borderRadius: "3px",
    backgroundColor: "#fff",
    padding: "15px",
    width: "620px",
  },
  categoryItem: {
    alignItems: "center",
    border: "1px solid #e0e0e0",
    display: "grid",
    gap: "5px",
    gridAutoColumns: "1fr",
    gridAutoRows: "75px",
    gridTemplateRows: "40px",
    justifyContent: "center",
    padding: "15px 0",
    width: "100%",
  },
  categoryLabel: {
    padding: "0 15px",
    // width: "calc(100% - 15px)",
    alignSelf: "end",
    textAlign: "start",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    height: "100%",
    userSelect: "none",
    "& :last-child": {
      marginLeft: "auto",
    },
  },
  competitorItem: {
    justifySelf: "center",
    height: "95%",
    width: "95%",
  },
  addCompetitorItem: {
    alignItems: "center",
    backgroundColor: "#fff",
    border: "2px dotted #e0e0e0",
    borderRadius: "3px",
    cursor: "pointer",
    display: "flex",
    height: "45px",
    justifySelf: "center",
    userSelect: "none",
    width: "95%",
  },
  disabledAddCompetitorItem: {
    cursor: "not-allowed",
    backgroundColor: "#EEEEEE",
  },
  disabledAddCompeitorText: {
    paddingLeft: "30px",
  },
  collapseRowContainer: {
    display: "flex",
    flexDirection: "column",
  },
}));

export default function CompetitorListComponent({
  slidersData,
  setSlidersData,
  competitorsFilters,
}) {
  const classes = useStyles();

  const handleAddItem = (newItem) => {
    setSlidersData((prevState) => {
      const newState = _.cloneDeep(prevState);
      if (
        competitorsFilters.groupBy.key === "category-company" ||
        !newItem.brandIdx
      ) {
        const { companies } = newState[newItem.categoryIdx];
        companies[newItem.companyIdx].isShowed = true;
        return newState;
      }
      const { companies } = newState[newItem.categoryIdx];
      const { brands } = companies[newItem.companyIdx];
      brands[newItem.brandIdx].isShowed = true;
      return newState;
    });
  };

  const handleDeleteCompany = (companyIdx, categoryIdx) => {
    setSlidersData((prevState) => {
      const newState = _.cloneDeep(prevState);
      const { companies } = newState[categoryIdx];
      companies[companyIdx].isShowed = false;
      return newState;
    });
  };

  let filteredCategories = slidersData;
  if (
    _.some(
      _.pick(competitorsFilters, ["brand", "category", "company"]),
      (value) => value !== ""
    )
  ) {
    filteredCategories = _.filter(slidersData, (category) => {
      // First check if the category filter is not empty
      if (
        competitorsFilters.category &&
        competitorsFilters.category.length > 0
      ) {
        return _.some(competitorsFilters.category, { id: category.id });
      }

      // If the company filter is not empty, perform company filtering
      if (competitorsFilters.company && competitorsFilters.company.length > 0) {
        return _.some(category.companies, (company) => {
          return _.some(competitorsFilters.company, { id: company.id });
        });
      }

      if (competitorsFilters.company && competitorsFilters.company.length > 0) {
        return _.some(category.companies, (company) => {
          return _.some(competitorsFilters.company, { id: company.id });
        });
      }

      // Check if there is a brand filter (even without a company filter)
      if (competitorsFilters.brand && competitorsFilters.brand.length > 0) {
        return _.some(category.companies, (company) => {
          return _.some(company.brands, (brand) => {
            return _.some(competitorsFilters.brand, (filter) => {
              return filter.id === brand.id;
            });
          });
        });
      }

      // Fallback: if neither category nor company is valid
      return false;
    });
  }

  return (
    <Box className={classes.mainContainer}>
      {filteredCategories.map((category, categoryIdx) => {
        const filteredCompanies = filterCollectionByFilterName(
          "company",
          category.companies,
          competitorsFilters
        );

        const unshowedCompanies = getHiddenCompanies(
          category.companies,
          categoryIdx
        );

        if (filteredCompanies.length <= 0) return null;

        return (
          <Box key={category.id} className={classes.collapseRowContainer}>
            <CompetitorCollapseRow
              key={category.label}
              label={`${category.label}`}
              isCollapsed={category.isColapsed}
            >
              {filteredCompanies.map((company, companyIdx) => {
                const filteredBrands = filterCollectionByFilterName(
                  "brand",
                  company.brands,
                  competitorsFilters
                );
                const unshowedBrands = getHiddenBrands(
                  company.brands,
                  categoryIdx,
                  companyIdx
                );

                let companyIncludeInAFilter = false;

                if (
                  _.some(
                    _.pick(competitorsFilters, ["brand", "company"]),
                    (value) => value !== ""
                  )
                ) {
                  companyIncludeInAFilter =
                    (competitorsFilters.brand !== "" &&
                      _.some(company.brands, (obj1) =>
                        _.find(competitorsFilters.brand, { id: obj1.id })
                      )) ||
                    (competitorsFilters.company !== "" &&
                      _.find(competitorsFilters.company, { id: company.id }));
                }

                if (filteredBrands.length <= 0) return null;
                return (
                  <>
                    {(company.isShowed ||
                      companyIncludeInAFilter ||
                      competitorsFilters.company !== "") && (
                      <>
                        {competitorsFilters.groupBy.key ===
                          "category-company-brand" && (
                          <CompetitorCollapseRow
                            key={company.id}
                            isNested
                            label={`${company.label}`}
                            isCollapsed={company.isColapsed}
                            onDeleteRow={() =>
                              handleDeleteCompany(companyIdx, categoryIdx)
                            }
                          >
                            {filteredBrands.map((brand, brandIdx) => {
                              if (!brand.label) return null;
                              return (
                                <>
                                  {(brand.isShowed ||
                                    competitorsFilters.brand !== "") && (
                                    <CompetitorSliderRow
                                      key={brand.id}
                                      label={brand.label || "NO_NAME"}
                                      competitorsFilters={competitorsFilters}
                                      setSlidersData={setSlidersData}
                                      sliderValue={brand.sliderValue}
                                      price={brand.price}
                                      companyId={company.id}
                                      brandId={brand.id}
                                      categoryId={category.id}
                                      brandIdx={brandIdx}
                                      companyIdx={companyIdx}
                                      categoryIdx={categoryIdx}
                                    />
                                  )}
                                </>
                              );
                            })}
                            {competitorsFilters.brand === "" && (
                              <CompetitorAddItemsComponent
                                label="+ Add other brands"
                                unshowedItems={unshowedBrands}
                                onAddItem={handleAddItem}
                              />
                            )}
                          </CompetitorCollapseRow>
                        )}
                        {competitorsFilters.groupBy.key ===
                          "category-company" && (
                          <CompetitorSliderRow
                            key={company.id}
                            label={company.label}
                            competitorsFilters={competitorsFilters}
                            price={company.price}
                            setSlidersData={setSlidersData}
                            sliderValue={company.sliderValue}
                            companyId={company.id}
                            categoryId={category.id}
                            companyIdx={companyIdx}
                            categoryIdx={categoryIdx}
                          />
                        )}
                      </>
                    )}
                  </>
                );
              })}
              {!_.some(
                _.pick(competitorsFilters, ["brand", "category", "company"]),
                (value) => value !== ""
              ) && (
                <CompetitorAddItemsComponent
                  label="+ Add other companies"
                  unshowedItems={unshowedCompanies}
                  onAddItem={handleAddItem}
                />
              )}
            </CompetitorCollapseRow>
          </Box>
        );
      })}
    </Box>
  );
}
